import { Component, ElementRef, EventEmitter, Host, Input, NgZone, Optional, Output, TemplateRef, ViewChild } from "@angular/core";
import { NzNoAnimationDirective } from "ng-zorro-antd/core/no-animation";
import { NzSafeAny } from "ng-zorro-antd/core/types";
import { NzSelectTopControlComponent } from "ng-zorro-antd/select";
import { UiSelectSearchComponent } from "@webapp/ui/select/components/select-search/select-search.component";
import { UiSelectItemInterface, UiSelectModeType } from "@webapp/ui/select/select.models";

@Component({
  selector: "ui-select-top-control",
  exportAs: "uiSelectTopControl",
  templateUrl: "select-top-control.component.html",
})
export class UiSelectTopControlComponent extends NzSelectTopControlComponent {
  // we keep the imports here due to the typings that were r elated to NzSelect and overridden with UiSelect
  @Input() public nzId: string | null = null;
  @Input() public showSearch = false;
  @Input() public placeHolder: string | TemplateRef<NzSafeAny> | null = null;
  @Input() public open = false;
  @Input() public maxTagCount = Infinity;
  @Input() public autofocus = false;
  @Input() public disabled = false;
  @Input() public mode: UiSelectModeType = "default";
  @Input() public customTemplate: TemplateRef<{ $implicit: UiSelectItemInterface }> | null = null;
  @Input() public maxTagPlaceholder: TemplateRef<{ $implicit: NzSafeAny[] }> | null = null;
  @Input() public removeIcon: TemplateRef<NzSafeAny> | null = null;
  @Input() public listOfTopItem: UiSelectItemInterface[] = [];
  @Input() public tokenSeparators: string[] = [];
  @Output() public readonly tokenize = new EventEmitter<string[]>();
  @Output() public readonly inputValueChange = new EventEmitter<string>();
  @Output() public readonly deleteItem = new EventEmitter<UiSelectItemInterface>();
  @ViewChild(UiSelectSearchComponent) public nzSelectSearchComponent!: UiSelectSearchComponent;

  constructor(uiElementRef: ElementRef<HTMLElement>, uiNgZone: NgZone, @Host() @Optional() noAnimation: NzNoAnimationDirective | null) {
    super(uiElementRef, uiNgZone, noAnimation);
  }
}
